import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

/* Action types and creators */

export const { Types, Creators } = createActions({
  requestWaitingTickets: [],
  successWaitingTickets: [],
  failureWaitingTickets: []
});

/* Reducer handlers */

const INITIAL_STATE = Immutable({
  data: {
    tickets: [],
    summary: []
  },
  loading: false,
  error: false
});

const requestWaitingTickets = (state = INITIAL_STATE) =>
  ({ ...state, loading: true, error: false });

const successWaitingTickets = (state = INITIAL_STATE, action) => {
  let summary = [];

  action.payload.forEach((ticket) => {
    const filtered = summary.filter((line) => line.id === ticket.lineId);
    let count = 1;

    if (filtered.length > 0) {
      count = filtered[0].count + 1;
      summary = summary.filter((line) => line.id !== ticket.lineId);
    }

    summary.push({
      id: ticket.lineId,
      name: ticket.lineName,
      color: ticket.lineColor,
      count
    });
  });

  return {
    ...state,
    data: {
      tickets: action.payload,
      summary
    },
    error: false,
    loading: false
  };
};

const failureWaitingTickets = (state = INITIAL_STATE) =>
  ({ ...state, loading: false, error: true });

/* Reducer */

export default createReducer(INITIAL_STATE, {
  [Types.REQUEST_WAITING_TICKETS]: requestWaitingTickets,
  [Types.SUCCESS_WAITING_TICKETS]: successWaitingTickets,
  [Types.FAILURE_WAITING_TICKETS]: failureWaitingTickets
});
